// Homepage "hero" defaults (EN + FR): today's text, used for any field left empty in the
// admin (Website → Homepage). The phone number is shared (English side only). The
// background photo/video is not here: the built-in clip in src/Sections/Hero is the fallback.
const HERO_DEFAULTS = {
  "en": {
    "title": "Licensed Security Guard Services in Montreal, Toronto & Ottawa",
    "subtitle": "Whatever your security needs, we have a solution. Licensed guards, mobile patrols, event security & 24/7 surveillance across Montreal, Toronto, Ottawa & beyond.",
    "ctaLabel": "Get a Quote",
    "callLabel": "Call Us",
    "callText": "or call",
    "phone": "514-279-7209",
    "badges": [
      { "text": "BSP licence GAR 20062877" },
      { "text": "PSISA #30000230" },
      { "text": "$5M insured" }
    ],
    "lastBadge": "24/7 dispatch"
  },
  "fr": {
    "title": "Services d'agents de sécurité licenciés à Montréal, Toronto et Ottawa",
    "subtitle": "Quels que soient vos besoins en sécurité, nous avons une solution. Agents licenciés, patrouille mobile, sécurité événementielle et surveillance 24/7 à Montréal, Toronto, Ottawa et ailleurs.",
    "ctaLabel": "Devis rapide",
    "callLabel": "Appelez-nous",
    "callText": "ou appelez le",
    "badges": [
      { "text": "Permis BSP GAR 20062877" },
      { "text": "PSISA #30000230" },
      { "text": "Assurance 5 M$" }
    ],
    "lastBadge": "Répartition 24/7"
  }
};

export default HERO_DEFAULTS;
